import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorks(companyId, query) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS,
		dtConfig[ModulesMap.DONE_WORKS].getDoneWorks,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}
function getDoneWorkPreview(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS,
		dtConfig[ModulesMap.DONE_WORKS].getDoneWorkPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorkPopup(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS,
		dtConfig[ModulesMap.DONE_WORKS].getDoneWorkPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}

function createDoneWork(companyId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS,dtConfig[ModulesMap.DONE_WORKS].createDoneWork, {
		urlParams: {
			companyId,
		},
		...data,
	})
}

function getDoneWork(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS,dtConfig[ModulesMap.DONE_WORKS].getDoneWork, {
		urlParams: {
			companyId,
			doneWorkId,
		},
	})
}

function patchDoneWork(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS,dtConfig[ModulesMap.DONE_WORKS].patchDoneWork, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function putDoneWork(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS,dtConfig[ModulesMap.DONE_WORKS].putDoneWork, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function deleteDoneWork(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS,dtConfig[ModulesMap.DONE_WORKS].deleteDoneWork, {
		urlParams: {
			companyId,
			doneWorkId,
		},
	})
}

export default {
	getDoneWorks,
	getDoneWorkPopup,
	getDoneWorkPreview,
	getDoneWork,
	patchDoneWork,
	putDoneWork,
	createDoneWork,
	deleteDoneWork,
}
